import {
  FETCH_BOOKING_DATA_ERROR,
  // ##### 23-12-22 Komarov
  FETCH_BOOKING_DATA_SUCCESS,
  FETCH_PAYMENT_DATA_ERROR,
  FETCH_PAYMENT_DATA_SUCCESS,
  FETCH_PAYMENT_INFO_REQUEST,
  FETCH_SET_PAYMENT_INFO_ERROR,
  FETCH_SET_PAYMENT_INFO_SUCCESS,
  GET_PAYMENT_INFO,
  SET_PAYMENT_INFO,
} from '../actions/types';

const initialState = {
  paymentInfo: null,
  // ##### 23-12-22 Komarov
  bookingInfo: null,
  loading: true,
  error: null,
};

const payment = (state = initialState, action) => {
  const { payload } = action;

  switch (action.type) {
    case SET_PAYMENT_INFO:
    case GET_PAYMENT_INFO:
    case FETCH_PAYMENT_INFO_REQUEST:
    case FETCH_SET_PAYMENT_INFO_SUCCESS:
    case FETCH_SET_PAYMENT_INFO_ERROR:
    case FETCH_PAYMENT_DATA_ERROR:
      return { ...state, paymentInfo: payload, loading: true };

    case FETCH_PAYMENT_DATA_SUCCESS:
      return { ...state, paymentInfo: payload, loading: false };

    case FETCH_BOOKING_DATA_SUCCESS:
      return { ...state, bookingInfo: payload, loading: false };

    case FETCH_BOOKING_DATA_ERROR:
      return { ...state, bookingInfo: payload, loading: true };

    default:
      return state;
  }
};

export default payment;
